module.exports = "/assets/621eba2810d7b21dc1318999524862fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/BC.png
// module id = 2354
// module chunks = 0